module.exports = __webpack_public_path__ + "img/logo.a942c036.png";